import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';

import {Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})

export class PopupNotificationService {
  private readonly url = 'iam-common/popup-notification';

  constructor(private http: HttpClient) {
  }

  get(): Observable<any> {
    return this.http.get(`${this.url}`);
  }

  markViewed(hasSeen:any): Observable<any> {
    return this.http.put(`${this.url}/mark-viewed?hasSeen=${hasSeen}`, {});
  }
}
